// src/services/patientInvoices.js
//
// Patient invoices (read-only). The patient is always the authenticated
// session. Errors are thrown unchanged (axios errors carry `response.status`
// and `response.data`), so pages read them with readApiError/apiErrorCode.

import { api } from "../lib/patientApi";
import { filenameFromContentDisposition, normalizeBlobError } from "../lib/download";

const BASE = "/api/v1/patients/me/invoices";

function clean(params = {}) {
  return Object.fromEntries(
    Object.entries(params).filter(([, value]) => value !== undefined && value !== null && !(typeof value === "string" && value.trim() === ""))
  );
}

export const patientInvoicesApi = {
  async list(params = {}, { signal } = {}) {
    const res = await api.get(BASE, { params: clean(params), signal });
    return res.data;
  },

  async filterOptions(params = {}, { signal } = {}) {
    const res = await api.get(`${BASE}/filter-options`, { params: clean(params), signal });
    return res.data;
  },

  async detail(invoiceId, { signal } = {}) {
    const res = await api.get(`${BASE}/${encodeURIComponent(invoiceId)}`, { signal });
    return res.data;
  },

  /** -> { blob, filename }. Error bodies (JSON sent as a blob) are parsed back into `response.data`. */
  async downloadPdf(invoiceId, invoiceNumber = "invoice") {
    try {
      const res = await api.get(`${BASE}/${encodeURIComponent(invoiceId)}/pdf`, { responseType: "blob" });
      const header = res.headers?.["content-disposition"] || res.headers?.["Content-Disposition"];
      return {
        blob: res.data,
        filename: filenameFromContentDisposition(header, `${invoiceNumber || "invoice"}.pdf`),
      };
    } catch (err) {
      throw await normalizeBlobError(err);
    }
  },
};

export default patientInvoicesApi;
